<div class="container" [ngClass]="{ 'corporate-loyalty-nav': isCorporate, 'kids-loyalty-nav': isKid }">
  <nav class="nav mixed-loyalty-nav mt-lg-4 mb-lg-0 mb-4 d-flex flex-row justify-content-start" *autoScrollNavbar="'mixed-loyalty-nav'">
    <a
      class="nav-item nav-item-all"
      [routerLink]="['/rewards']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/rewards')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.marketplace' | translate: { fgbdefault: 'Move to marketplace page' } }}"
    >
      <label>{{ 'rewards.nav.marketplace' | translate: { fgbdefault: 'Rewards' } }}</label>
    </a>

    <a
      *notInPopulation="[population.JuniorBluebirds]"
      class="nav-item"
      [routerLink]="['/rewards/events']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/rewards/events')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.event' | translate: { fgbdefault: 'Move to events page' } }}"
    >
      <label>{{ 'rewards.nav.event' | translate }}</label>
    </a>

    <a
      *notInPopulation="[population.JuniorBluebirds]"
      class="nav-item nav-item-events"
      [routerLink]="['/rewards/auctions']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/rewards/auctions')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.auction' | translate: { fgbdefault: 'Move to auctions page' } }}"
    >
      <label>{{ 'rewards.nav.auction' | translate }}</label>
    </a>

    <a
      class="nav-item"
      [routerLink]="['/rewards/raffles']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/rewards/raffles')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.lottos' | translate: { fgbdefault: 'Move to lottos page' } }}"
    >
      <label>{{ 'rewards.nav.lottos' | translate }}</label>
    </a>

    <a
      class="nav-item d-lg-flex d-none"
      [routerLink]="['/rewards/wallet']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/rewards/wallet')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.wallet' | translate: { fgbdefault: 'Move to wallet page' } }}"
    >
      <label>{{ 'rewards.nav.wallet' | translate }}</label>
    </a>
  </nav>
</div>
